import React from 'react';
import * as productAction from './../../actions/product';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  Link
} from "react-router-dom";


class OwlCarousels extends React.Component{
	constructor(props){
            super(props);
            this.state = {
                tuideo:"Thời trang",
                color:"tuideo",
                link:"",
                themeSuner:[
                    {
                        nameTheme:this.thoitrang,
                        class:"tuideo",
                        img:"https://cdn.glitch.com/1a2d3926-a597-412c-a998-a0aa2ca0b31a%2FB%E1%BA%A3n%20sao%20c%E1%BB%A7a%20Real%20Love.png?v=1596158353425"
                    },
                    {
                        nameTheme:this.phukien,
                        class:"sovo",
                        img:"https://cdn.glitch.com/1a2d3926-a597-412c-a998-a0aa2ca0b31a%2FB%E1%BA%A3n%20sao%20c%E1%BB%A7a%20Real%20Love%20(1).png?v=1596158881530"
                    },
                    {
                        nameTheme:this.dungcu,
                        class:"ocean",
                        img:"https://cdn.glitch.com/1a2d3926-a597-412c-a998-a0aa2ca0b31a%2FB%E1%BA%A3n%20sao%20c%E1%BB%A7a%20Real%20Love%20(2).png?v=1596159093083"
                    },
                    {
                        nameTheme:this.latvat,
                        class:"chanmeo",
                        img:"https://cdn.glitch.com/1a2d3926-a597-412c-a998-a0aa2ca0b31a%2FB%E1%BA%A3n%20sao%20c%E1%BB%A7a%20Real%20Love%20(3).png?v=1596159398853"
                    }
                    
                ]
        	}
    }

    showThemeSuner = (datas) =>{
            var result = null;
                result = datas.slice(0,4).map((data, index)=>{
                    return ( 
                        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3" key={index} id={ data.class === this.state.color ? "opacity" : "opacity_not"}>
                            <Link to="/">
                                <div className={data.class} onClick={data.nameTheme}>
                                    <img src={data.img}/>
                                </div>
                            </Link>
                        </div>
                    )
                })
            return result
    }


    showTable = (datas) =>{
        var result = null;
            result = datas.slice(0,4).map((product, index)=>{
                return ( 
                    <div className="col-xs-6 col-sm-4 col-md-4 col-lg-4" style={{paddingRight:"6px", paddingLeft: "6px"}} id={ product.conten === this.state.tuideo ? "" : "display_not"} key={index}>
                        <Link to={`product/${product._id}`}>
                            <div className="colection1" >
                            <img src={ product.imgeFile ? product.imgeFile : ""} />

                            </div>
                            <div className="title_product">
                                <p>NEW PRINTS</p>
                                <b>{product.products}</b>
                                <hr/>
                                <span>Gia {product.price}.000 Vnd</span>
                            </div>
                        </Link>
                    </div>
                )
            })
        return result
    }


	thoitrang=()=>{
		this.setState({tuideo:"Thời trang", color:"tuideo",link:"thoitrang"})
	}

	phukien=()=>{
		this.setState({tuideo:"Phụ kiện tiện ích", color:"sovo",link:"phukien"})
	}
	dungcu=()=>{
		this.setState({tuideo:"Văn phòng phẩm", color:"ocean",link:"dungcu"})
	}
	latvat=()=>{
		this.setState({tuideo:"Lặt vặt", color:"chanmeo",link:"latvat"})
	}

	render(){ 
		const {listProducts} = this.props;
        const {themeSuner} = this.state
			return ( 
				<div>
					<div className="out_soure">
                        <div className="img_out" style={{background:"none", padding:"80px 400px", height:"189px"}}>
                            <span class="t1"><b>●</b> &nbsp;TAKE A LOOK</span>
                            <h3>Chủ đề mới</h3>
                            <hr/>
                        </div>
                        <div class="row active custom_row">
                        	{this.showThemeSuner(themeSuner)}
                        </div>
                        <div className="box_main">
		                    {listProducts ? this.showTable(listProducts) : <div className="loading" style={{marginTop:"0", padding:"40px"}}>Loading&#8230;</div>}
		                </div>
                        <div className="send_mail">
                            <Link to={this.state.link}>
                                <button type="button">Xem Them</button>
                            </Link>
                        </div>
                    </div>
				</div>
	    	)
	    }
	}

OwlCarousels.propTypes = {
    productActionCreator: PropTypes.shape({
        fetchListProduct: PropTypes.func,
    }),
    listProducts: PropTypes.array,
}

const mapStateToProps = state =>{
    return{
        listProducts : state.products.listProduct,
    };
}
const mapDispatchToProps = dispatch => {
    return {
        productActionCreator: bindActionCreators(productAction, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OwlCarousels);